import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactTooltip from "react-tooltip";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import Contact from "../base/Contact";
import UITableUtils from "../util/UITableUtils";
import CollapsibleNote from "../base/CollapsibleNote";

import UIUtils from "../util/UIUtils";
import ApiUtils from '../util/ApiUtils';
import "../styles/charts.css";
import "./Relayers.css";
import Utilities from "../util/Utilities";
import RespUtils from "../util/RespUtils";

import constants from '../constants';
import DataUtils from '../util/DataUtils';
import ProjectUIUtils from '../projects/ProjectUIUtils';
import RelayerUtils from './RelayerUtils';
import ChartTitle from '../components/ChartTitle';

class Networks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      networks: [],
      notification: {"message": null},
      width: window.innerWidth,
      size: 10,
      isLoading: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.reload = this.reload.bind(this);
    this.getInitColumns = this.getInitColumns.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    let url = "networks";
    const allData = await ApiUtils.get(url);
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    let networks = allData["networks"];
    if (networks) {
        networks = DataUtils.addIndex(networks, "symbol");
        this.setState({networks: networks});
    }

    this.setState({isLoading: false});
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);
    if (loadMsg) return loadMsg;

    const headerSortingClasses = (column, sortOrder, isLastSorting, colIndex) => (
      sortOrder === 'asc' ? 'sorting-asc' : 'sorting-desc'
    );
    
    var columns = [
      {text: "#", desc: "Index", hidden: RespUtils.isMobileView(), dataField: "index", sort: true, align: "left", headerStyle: Utilities.width(4), headerSortingClasses},
      {text: "Name", desc: "Chain", hidden: this.isHidden("name"), dataField: "name", formatter: RelayerUtils.networkNameFormatterTableWithLogoNoTrim, sort: true, headerStyle: Utilities.respWidth(50, 35, 20), headerSortingClasses},
      {text: "Media",  desc: "Chain Contact Info", hidden: RespUtils.isTabletView(), dataField: "twitter", formatter: ProjectUIUtils.formatMedia, sort: true, headerStyle: Utilities.respWidth(20, 20, 10), headerSortingClasses},
      {text: "Relayer Count",  desc: "Relayer Count", hidden: this.isHidden("relayerCount"), dataField: "relayerCount", sort: true, headerStyle: Utilities.respWidth(30, 25, 25), headerSortingClasses},
      {text: "Status", desc: "Status", hidden: RespUtils.isMobileView(), dataField: "lastUpdatedGap", formatter: RelayerUtils.getChainStatus, sort: true, headerStyle: Utilities.width(5), headerSortingClasses},
    ];

    const options = {
      onlyOneExpanding: true,
    };

    return (
      <div>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <ToolkitProvider keyField="index" data={this.state.networks} columns={columns} columnToggle>
          {
            props => (
              <div>
                <ChartTitle title="Networks" />
                <BootstrapTable options={options} { ...props.baseProps } filter={ filterFactory() }
                    condensed noDataIndication="No Data" />
              </div>
            )
          }
        </ToolkitProvider>
        <p/>
        <p>Based on data submitted to Smart Stake via the <a href="https://github.com/SmartStake/relayers" target="_blank" title="github" className="mediaCustom fab fa-github fa-md"> Github</a> repo. There are likely many more relayers for each chain</p>
        <p>Update your (or your favorite) relayer's data at <a href="https://github.com/SmartStake/relayers" target="_blank" title="github" className="mediaCustom fab fa-github fa-md"> Github</a></p>
        <CollapsibleNote getScreenGuide={RelayerUtils.getRelayersNote} />
        <Contact />
      </div>
    );
  }

  reload() {
    window.location = "/";
  }

  getInitColumns() {
    let columnsConfig = {};
    if (RespUtils.isTabletView()) {
      columnsConfig = {
        index: true, name: false, twitter: false, relayerCount: false, 
      };

    } else {
      columnsConfig = {
        index: false, name: false, twitter: false, relayerCount: false, 
      };
    }

    // console.log("columns config is: ", columnsConfig);
    return columnsConfig;
  }

  isHidden(dataField) {
    return UITableUtils.isHidden(constants.app.VALIDATORS_KEY, dataField, this.getInitColumns);
  }

}

export default Networks;
